import { useQuery } from '@tanstack/react-query';
import { deviceApi } from '../../services/api';

export const deviceKeys = {
  all: ['devices'] as const,
  list: (orgId?: string) => ['devices', 'list', orgId] as const,
  detail: (deviceId: string) => ['devices', 'detail', deviceId] as const,
};

export function useDevices(orgId?: string) {
  return useQuery({
    queryKey: deviceKeys.list(orgId),
    queryFn: () => deviceApi.getDevices(orgId || ''),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (data) => (Array.isArray(data) ? data : []),
  });
}

export function useDeviceDetail(deviceId: string | undefined) {
  return useQuery({
    queryKey: deviceKeys.detail(deviceId!),
    queryFn: () => deviceApi.getDeviceDetail(deviceId!),
    enabled: !!deviceId,
    staleTime: 15_000,
  });
}
